import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class RolemoduleApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'rolemodule'
    }

    /**
     * 根据角色查询权限菜单
     * @returns 
     */
    public getListByRoleId(roleId){
        return this.send({roleId: roleId},"getListByRoleId",Methods.GET)
    }

    /**
     * 根据角色id删除权限
     * @param roleId
     */
    public deleteByRoleId(roleId){
        return this.send({},"deleteByRoleId?roleId="+roleId,Methods.POST)
    }

    /**
	 * 角色id和类型查询菜单
	 * 1、pc端 2、app或者小程序
	 */
	public getModuleListByRoleIdAndType(roleId,type = 1){
		return this.send({roleId: roleId,type:type},"getModuleListByRoleIdAndType",Methods.GET)
	}


    /**
     * 查询是否绑定了角色
     * @param roleId
     */
    public getIsBind(subSystemId,moduleId){
        return this.send({subSystemId:subSystemId,moduleId:moduleId},"getIsBind",Methods.GET)
    }


}